function parseFecha(fecha) {
  const [y, m, d] = String(fecha).slice(0, 10).split('-').map(Number)
  return new Date(y, m - 1, d)
}

function monthName(date) {
  return date.toLocaleDateString('es', { month: 'short' }).replace('.', '')
}

// Se queda con las etiquetas que caben sin pisarse, conservando siempre la
// primera y la última. x de cada punto = reparto uniforme por posición.
function thin(items, n, usableWidth, minGap) {
  if (items.length === 0) return items
  const xOf = i => (i / (n - 1)) * usableWidth
  const kept = [items[0]]
  for (const it of items.slice(1)) {
    if (xOf(it.i) - xOf(kept[kept.length - 1].i) >= minGap) kept.push(it)
  }
  const last = items[items.length - 1]
  if (kept[kept.length - 1] !== last) {
    if (kept.length > 1 && xOf(last.i) - xOf(kept[kept.length - 1].i) < minGap) kept.pop()
    kept.push(last)
  }
  return kept
}

// Calcula las etiquetas del eje X de una serie con fechas (campo `fecha`):
// - Hasta ~2 meses: solo el número del día bajo cada punto, y el mes
//   saliente a la izquierda / el entrante a la derecha (el mismo en ambos
//   lados si todo cae en un único mes).
// - Rangos más largos: el nombre del mes en el primer punto de cada mes.
// Si algún punto no trae fecha, se usan sus etiquetas completas, espaciadas.
export function buildXAxis(data, usableWidth) {
  const n = data.length
  if (n < 2) return { ticks: [], leftMonth: null, rightMonth: null }

  if (data.some(d => !d.fecha)) {
    const all = data.map((d, i) => ({ i, text: d.label }))
    return { ticks: thin(all, n, usableWidth, 34), leftMonth: null, rightMonth: null }
  }

  const dates = data.map(d => parseFecha(d.fecha))
  const spanDays = (dates[n - 1] - dates[0]) / 86400000

  if (spanDays <= 62) {
    const all = dates.map((dt, i) => ({ i, text: String(dt.getDate()) }))
    return {
      ticks: thin(all, n, usableWidth, 18),
      leftMonth: monthName(dates[0]),
      rightMonth: monthName(dates[n - 1]),
    }
  }

  const starts = []
  dates.forEach((dt, i) => {
    const prev = dates[i - 1]
    if (i === 0 || dt.getMonth() !== prev.getMonth() || dt.getFullYear() !== prev.getFullYear()) {
      starts.push({ i, text: monthName(dt) })
    }
  })
  return { ticks: thin(starts, n, usableWidth, 24), leftMonth: null, rightMonth: null }
}
